import Vue from 'vue'
import moment from 'moment'

Vue.filter('duration', (d, b, e) => {
  let diff = moment.preciseDiff(moment(d[b]), moment(d[e]))
  diff = diff.replace('days', '天')
  diff = diff.replace('day', '天')
  diff = diff.replace('hours', '小时')
  diff = diff.replace('hour', '小时')
  diff = diff.replace('minutes', '分钟')
  diff = diff.replace('minute', '分钟')
  diff = diff.replace('seconds', '秒')
  diff = diff.replace('second', '秒')
  return diff
})
